const Error404 = () => {
    return <h3>No match found</h3>
}

export default Error404;